export default "__VITE_ASSET__BN$G5MYQ__"